import React from 'react';
import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';
import Colors from '../constants/Colors';
import { B } from './Typography';

const StyledListView = styled.View`
  width: 100%;
`;

const StyledItemView = styled.View`
  width: 80px;
  align-items: center;
`;

const StyledImage = styled.Image`
  width: 80px;
  height: 80px;
  border-radius: 40px;
`;

const StyledCategoryText = styled(B)`
  margin-top: 16px;
  text-align: center;
  color: ${Colors.primary};
`;

const StyledSeparator = styled.View`
  width: 24px;
`;

export interface WellnessCategory {
  imageUrl: string;
  category: string;
}

interface WellnessCategoryListProps {
  categories: WellnessCategory[];
}

const WellnessCategoryList: React.FC<WellnessCategoryListProps> = ({
  categories
}) => {
  return (
    <StyledListView>
      <FlatList
        keyExtractor={(_, index) => index.toString()}
        horizontal
        overScrollMode='never'
        showsHorizontalScrollIndicator={Platform.OS === 'web'}
        data={categories}
        initialNumToRender={10}
        maxToRenderPerBatch={10}
        ItemSeparatorComponent={() => <StyledSeparator />}
        renderItem={listItem => {
          return (
            <StyledItemView>
              <StyledImage
                resizeMode='cover'
                source={{ uri: listItem.item.imageUrl }}
              />
              <StyledCategoryText>{listItem.item.category}</StyledCategoryText>
            </StyledItemView>
          );
        }}
      />
    </StyledListView>
  );
};

export default WellnessCategoryList;
